import { updateInitialConfig, updateModifiedConfig } from "../checksumStore";

export const updateFormChecksum = (formData, isInit = false) => {
  let storeConfig = {
    form: {},
    activity: {}
  };
  storeConfig.form = processFormOnlyData(formData.form);
  storeConfig.activity = processFormActivityData(formData);
  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }
  return storeConfig;
};

const processFormOnlyData = (form) => {
  const updatedSection = form.sections.map((sec) => {
    const copy = { ...sec };
    if (!copy.desktop_layout) {
      copy.desktop_layout = {
        outer_layout: []
      };
    }
    if (!copy.mobile_layout) {
      copy.mobile_layout = {
        outer_layout: []
      };
    }
    return copy;
  });
  return {
    name: form.name,
    sections: updatedSection,
    settings: form.settings,
    submit_button: form.submit_button,
    reset_button: form.reset_button,
    style: form.style,
    is_positioned_form: form.is_positioned_form || false
  };
};

const processFormActivityData = (activityData) => {
  const details = activityData.details_view || {};

  return {
    form_backend_validation: activityData.form_backend_validation,
    custom_js: activityData.custom_js || "",
    details_view: {
      detailview_id: details.detailview_id || "",
      detailview_id_for_mobile: details.detailview_id_for_mobile || "",
      detailview_id_for_tablet: details.detailview_id_for_tablet || "",
      is_positioned_static_data: details.is_positioned_static_data,
      position_config: details.position_config || {
        mobile: {
          config: [],
          position_config_ids: {}
        },
        desktop: {
          config: [],
          position_config_ids: {}
        }
      },
      elements: details.elements || []
    }
  };
};
